import { gql } from "@apollo/client";
import { client } from "graphql/client";
import {ExceptionDictionaryType} from "./getExceptionDictionaryForDelivery";

export const GET_EXCEPTION_DICTIONARY_ALL = gql`
    query GetExceptionDictionaryAll {
        getExceptionDictionaryAll {
            exceptionReasonCode
            primaryType
            secondaryTypeZh
            secondaryTypeEn
            secondaryTypeEs
            actionDescription
            isUploadsImages
            exceptionSubReasons {
                code
                textZh
                textEn
                textEs
            }
        }
    }
`;

export const GET_EXCEPTION_DICTIONARY_FOR_DSP = gql`
    query ExceptionDictionaryQuery {
        getExceptionDictionaryForDsp {
            exceptionReasonCode
            primaryType
            secondaryTypeZh
            secondaryTypeEn
            secondaryTypeEs
            actionDescription
            isUploadsImages
            exceptionSubReasons {
                code
                textZh
                textEn
                textEs
            }
        }
    }
`;

export interface ExceptionDictionaryResponse {
    getExceptionDictionaryForDsp: ExceptionDictionaryType[];
}

export interface ExceptionDictionaryAllResponse {
    getExceptionDictionaryAll: ExceptionDictionaryType[];
}

export const getExceptionDictionaryAll = async () => {
    const { data } = await client.query<ExceptionDictionaryAllResponse>({
        query: GET_EXCEPTION_DICTIONARY_ALL,
        fetchPolicy: 'cache-first'
    });
    return data?.getExceptionDictionaryAll || [];
};

export const getExceptionDictionaryForDsp = async () => {
    const { data } = await client.query<ExceptionDictionaryResponse>({
        query: GET_EXCEPTION_DICTIONARY_FOR_DSP,
        fetchPolicy: 'cache-first'
    });
    return data?.getExceptionDictionaryForDsp || [];
};  
